import { Component, Input } from '@angular/core';
import {
    isApprovalGranted,
    RequestersMissionApprovalDto
} from '@flyfreely-portal-ui/flyfreely';

@Component({
    selector: 'mission-approval-status',
    templateUrl: './mission-approval-status.component.html',
    styleUrl: './mission-approval-status.component.scss'
})
export class MissionApprovalStatusComponent {
    @Input()
    status?: RequestersMissionApprovalDto.Status;

    get isGranted() {
        return this.status != null && isApprovalGranted(this.status);
    }
}
